export abstract class Node {
  /**
   * Return an array of sub-nodes.
   */
  public abstract getNodes(): Node[];

  public abstract getReductionGroup(): string;
}
